import { render, staticRenderFns } from "./FaqCategoryList.vue?vue&type=template&id=32b4b50e&scoped=true"
import script from "./FaqCategoryList.vue?vue&type=script&lang=js"
export * from "./FaqCategoryList.vue?vue&type=script&lang=js"
import style0 from "./FaqCategoryList.vue?vue&type=style&index=0&id=32b4b50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4b50e",
  null
  
)

export default component.exports